import React, { ReactElement, useState, useRef } from 'react';
import styles from './TabComponent.module.scss';

interface iTabs {
  label: string;
  content: ReactElement;
  id: string;
}

interface iInput {
  tabs: iTabs[];
}

const TabComponent = ({ tabs }: iInput): ReactElement => {
  const [activeTab, setActiveTab] = useState(0);
  const tabRefs = useRef<(HTMLButtonElement | null)[]>([]);

  const focusTab = (index: number) => {
    tabRefs.current[index]?.focus();
  };

  const handleKeyDown = (e: React.KeyboardEvent, index: number) => {
    let newIndex = index;

    switch (e.key) {
      case 'ArrowRight':
        newIndex = (index + 1) % tabs.length;
        break;
      case 'ArrowLeft':
        newIndex = (index - 1 + tabs.length) % tabs.length;
        break;
      case 'Home':
        newIndex = 0;
        break;
      case 'End':
        newIndex = tabs.length - 1;
        break;
      default:
        return;
    }

    e.preventDefault();
    setActiveTab(newIndex);
    focusTab(newIndex);
  };

  return (
    <div>
      {/* Tab Headers */}
      <div className={styles.tabContainer} role="tablist" aria-label="Tab Navigation">
        {tabs.map((tab, index) => (
          <button
            key={tab.id}
            id={`${tab.id}`}
            type="button"
            role="tab"
            aria-selected={activeTab === index}
            aria-controls={`tabpanel-${tab.id}`}
            tabIndex={activeTab === index ? 0 : -1}
            ref={(el) => {
              tabRefs.current[index] = el;
            }}
            onClick={() => setActiveTab(index)}
            onKeyDown={(e) => handleKeyDown(e, index)}
            className={activeTab === index ? styles.activeTab : styles.defaultTab}>
            {tab.label}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div id={`tabpanel-${tabs[activeTab].id}`} role="tabpanel" aria-labelledby={`${tabs[activeTab].id}`} className={styles.tabContent} tabIndex={0}>
        {tabs[activeTab].content}
      </div>
    </div>
  );
};

export default TabComponent;
